import type { UnlockKind } from '@anidex/shared/economy';
import type { AnimeFilters, AtlasFilters, CollectionFilters } from './filters';

const accountKeys = {
  session: ['session'] as const,
  config: ['config'] as const,
  publicStats: ['public-stats'] as const,
  me: ['me'] as const,
};

const collectionKeys = {
  collection: (filters: CollectionFilters) => ['collection', filters] as const,
  
  ownedIds: ['collection', 'owned_ids'] as const,
  stashedFragments: ['collection', 'stashed_fragments'] as const,
  character: (id: number) => ['character', id] as const,
};

const catalogKeys = {
  publicCharacter: (id: number) => ['public_character', id] as const,
  publicAnime: (id: number) => ['public_anime', id] as const,
  animes: (filters: AnimeFilters) => ['animes', filters] as const,
  anime: (id: number, show: string, page = 0, sort = 'rarity') => ['anime', id, show, page, sort] as const,
};

const progressionKeys = {
  gacha: ['gacha'] as const,
  history: ['gacha-history'] as const,
  quests: ['quests'] as const,
  loginCalendar: ['login-calendar'] as const,
  harvest: ['harvest'] as const,
  achievements: ['achievements'] as const,
  
  unlocks: (owner: string) => ['unlocks', owner] as const,
  unlockKind: (owner: string, kind: UnlockKind) => ['unlocks', owner, kind] as const,
  ownedUnlocks: (kind: UnlockKind) => ['unlocks', 'owned', kind] as const,
};

const socialKeys = {
  friends: ['friends'] as const,
  referral: ['referral'] as const,
  friendRequests: ['friend_request'] as const,
  friendActivity: ['friend_activity'] as const,
  atlas: (filters: AtlasFilters) => ['atlas', filters] as const,
  blocks: ['blocks'] as const,
  userSearch: (q: string) => ['user_search', q] as const,
};

const messagingKeys = {
  summary: ['summary'] as const,
  notifications: ['notification'] as const,
  conversations: ['conversations'] as const,
  messages: (conversationId: string) => ['message', conversationId] as const,
};

const profileKeys = {
  publicProfile: (username: string) => ['public_profile', username] as const,
  publicCollection: (username: string, filters: CollectionFilters) => ['public_collection', username, filters] as const,
  compare: (username: string) => ['compare', username] as const,
  compareCards: (username: string, view: string, page = 0) => ['compare_cards', username, view, page] as const,
  settings: ['settings'] as const,
};

const marketKeys = {
  market: (filters: Record<string, unknown>) => ['market', filters] as const,
  marketMine: ['market_mine'] as const,
  auctionsMine: ['auctions_mine'] as const,
  marketHistory: ['market_history'] as const,
  auctions: (filters: Record<string, unknown>) => ['auctions', filters] as const,
  auction: (id: string) => ['auction', id] as const,
};

const tradeKeys = {
  trades: (box: string) => ['trades', box] as const,
  trade: (id: string) => ['trade', id] as const,
  partnerCards: (username: string, tradeId?: string, filters: Record<string, unknown> = {}) =>
    ['partner_cards', username, tradeId ?? '', filters] as const,
};

export const keys = {
  ...accountKeys,
  ...collectionKeys,
  ...catalogKeys,
  ...progressionKeys,
  ...socialKeys,
  ...messagingKeys,
  ...profileKeys,
  ...marketKeys,
  ...tradeKeys,
};
